import ChevronLeftIcon from '@mui/icons-material/ChevronLeft'
import close from 'assets/icons/close.png'
import styles from 'components/Navbar/Navbar.module.scss'
import React, { useState, useEffect } from 'react';
import SlidingPane from 'react-sliding-pane'
import './../styles/react-sliding-pane-custom.css'
// import Draggable from 'react-draggable';
const SlidingPaneUtil = ({
  children,
  state,
  setState,
  title,
  size,
  isWhite,
}) => {
  const customClass = isWhite ? 'custom_background' : styles.some_custom_class2
  
  const [position, setPosition] = useState({ x: 0, y: 0 });
  const [isDragging, setIsDragging] = useState(false);
  const [dragStartPos, setDragStartPos] = useState({ x: 0, y: 0 });
  
  useEffect(() => {
    if (isDragging) {
      const handleMouseMove = (e) => {
        const deltaX = e.clientX - dragStartPos.x;
        const deltaY = e.clientY - dragStartPos.y;
        setPosition({
          x: position.x + deltaX,
          y: position.y + deltaY
        });
        setDragStartPos({ x: e.clientX, y: e.clientY });
      };

      const handleMouseUp = () => {
        setIsDragging(false);
      };

      document.addEventListener('mousemove', handleMouseMove);
      document.addEventListener('mouseup', handleMouseUp);

      return () => {
        document.removeEventListener('mousemove', handleMouseMove);
        document.removeEventListener('mouseup', handleMouseUp);
      };
    }
  }, [isDragging, position, dragStartPos]);

  const handleMouseDown = (e) => {
    setIsDragging(true);
    setDragStartPos({ x: e.clientX, y: e.clientY });
  };



  return (
  
    <>
     <div
      style={{
        position: 'absolute',
        top: position.y + 'px',
        left: position.x + 'px',
        width: '100%',
        cursor: isDragging ? 'grabbing' : 'grab'
      }}
    >
       <SlidingPane
        className={customClass}
        overlayClassName={styles.some_custom_overlay_class2}
        isOpen={state.isPaneOpen}
        title={title}
        width={size}
        from="right"
        hideHeader={true}
        shouldCloseOnEsc={true}
        onRequestClose={() => {
          // triggered on "<" on left top click or on outside click
          setState({ isPaneOpen: false })
        }}
      >
          
       
          
    
   
        <div className={styles.sliding_pane_header} onMouseDown={handleMouseDown}
       >
          {window.innerWidth <= 600 ? (
            <img
              src={close}
              style={{
                width: '20px',
                height: '20px',
                cursor: 'pointer',
                marginTop: '15px',
                marginRight: '15px',
              }}
              alt=""
              onClick={() => {
                setState({ isPaneOpen: false })
              }}
            />
          ) : (
            <ChevronLeftIcon
              style={{ marginTop: '3px', cursor: 'pointer' }}
              onClick={() => {
                setState({ isPaneOpen: false })
              }}
            />
          )}
        {window.innerWidth <= 700 ? (
         <h2
         style={{ color: isWhite ? 'black' : 'black',fontWeight:"500",fontSize:'18px', paddingTop: '4px', margin: '10px',cursor: 'pointer' }}
       >
         {title}
       </h2>
          ) : (
            <h2
            style={{ color: isWhite ? 'black' : 'black',fontWeight:"500",fontSize:'18px', paddingTop: '4px', cursor: 'pointer' }}
          >
            {title}
          </h2>
          )}
          
      
        </div>
        {children}
       
      </SlidingPane>
      
      </div>
      <style>
        {`
          .custom_background {
            background: #fff; /* Set the background color to white */
          }
        `}
      </style>
    
    </>
 
  )
}
export default React.memo(SlidingPaneUtil)
